<template>
  <div class="cadfm-container-horizontal">
            <!-- <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left> -->
            <Middle   :lang="lang.Middle"></Middle>
            <!--<Right v-show="isVisibleRight" :lang="lang.Right"></Right>-->
 </div>
</template>

<script>
//import Left from '@/components/PartManager/Views/PartAssembly/Left/Left'
import Middle from '@/components/PartManager/Views/PartPhysicals/Middle/Middle'
//import Right from '@/components/PartManager/Views/Categories/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'


export default {
  name: 'PartPhysicals',
  components:{
    //Left,
    Middle,
    //Right
  },
  props:{
    routingData: Object,
    lang: Object
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartPhysicals.vue